import { render } from "./SearchItemTextbox.vue?vue&type=template&id=afe454da&scoped=true"
import script from "./SearchItemTextbox.vue?vue&type=script&lang=ts"
export * from "./SearchItemTextbox.vue?vue&type=script&lang=ts"

import "./SearchItemTextbox.vue?vue&type=style&index=0&id=afe454da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-afe454da"

export default script